<div>
  @if (auth.isloggedIn) {
    <nav class="fusion-navbar navbar navbar-expand-xl">
      <div class="container-fluid ps-nav">
        <!-- Brand -->
        <a class="navbar-brand fusion-brand" routerLink="/control-module">
          <div class="brand-logo-wrap">
            <img src="assets/img/logo-header.png" style="height:38px; display:inline-block; vertical-align:middle;">
          </div>
          <span class="brand-title">{{'HEADER.CONTROL_MODULE' | translate}}</span>
        </a>
        <!-- Mobile toggler -->
        <button class="navbar-toggler mobile-toggler-btn" type="button"
          (click)="toggleMobileMenu()"
          [attr.aria-expanded]="mobileMenuOpen"
          aria-label="Toggle navigation">
          <lucide-icon [name]="mobileMenuOpen ? 'x-lg' : 'list'" style="color:white; display:block;" size="21"></lucide-icon>
        </button>
        <!-- Nav + controls -->
        <div class="collapse navbar-collapse" id="cmMainNav">
          <!-- Left nav links -->
          <ul class="navbar-nav align-items-center me-auto">
            <li class="nav-item">
              <div ngbDropdown class="d-inline-block">
                <button type="button" class="btn btn-link nav-item-btn" ngbDropdownToggle>
                  <lucide-icon name="cpu" style="margin-right:4px;" size="16"></lucide-icon>
                  {{ controlTypeNameShort }}
                </button>
                <div ngbDropdownMenu>
                  @for (value of controlTypes; track value) {
                    <button ngbDropdownItem
                      (click)="onChangeType(value.key)">
                      {{value.name.split(":")[0]}}
                    </button>
                  }
                </div>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link nav-item-btn" routerLink="/control-module" routerLinkActive="nav-item-active">
                <lucide-icon name="list" style="margin-right:4px;" size="16"></lucide-icon>
                {{'HEADER.GENERAL' | translate}}
              </a>
            </li>
          </ul>
          <!-- Right controls -->
          <div class="d-flex align-items-center flex-shrink-0">
            @for (code of languages; track code) {
              <img [src]="flagFor(code)" (click)="setLang(code)" [alt]="code"
                class="lang-flag" [class.lang-flag-fr]="code === 'fr'"
                [ngClass]="lang === code ? '' : 'unselected_lang'">
            }
            <div ngbDropdown placement="bottom-end">
              <button class="btn btn-link header-icon-btn" ngbDropdownToggle (click)="setSeenAll()">
                <lucide-icon name="bell" size="24"></lucide-icon>
                @if (unseenNotifications > 0) {
                  <span class="notification_num">{{unseenNotifications}}</span>
                }
              </button>
              <div ngbDropdownMenu class="dropdown-menu-end">
                @for (value of dropDownNotifications?.slice(0,10); track value) {
                  <div style="width:100%;">
                    <button ngbDropdownItem style="font-size:15px; padding:10px 10px 10px 5px; width:100%;"
                      (click)="navigateToNotification(value)">
                      <lucide-icon name="dot" style="margin-right:2px;" size="24"></lucide-icon>
                      @if (value.referenceObject) {
                        {{'NOTIFICATIONS.'+value.type.toUpperCase() | translate: {task: '"'+value.referenceObject.name+'"'} }}
                      }
                      @if (!value.referenceObject) {
                        {{'NOTIFICATIONS.'+value.type.toUpperCase() | translate}}
                      }
                    </button>
                    <hr style="margin:0;" />
                  </div>
                }
                <button ngbDropdownItem style="text-align:center; color:var(--navy-600);"
                  (click)="navigateToNotifications()">
                  {{'NOTIFICATIONS.SEE_ALL' | translate}}
                </button>
              </div>
            </div>
            <div ngbDropdown placement="bottom-end">
              <button class="btn btn-link header-icon-btn user-avatar-btn" ngbDropdownToggle>
                <app-user-avatar [user]="user"></app-user-avatar>
              </button>
              <div ngbDropdownMenu class="dropdown-menu-end">
                <button type="button" ngbDropdownItem (click)="userAccount()">
                  <lucide-icon name="user" style="margin-right:4px;" size="18"></lucide-icon>
                  {{this.user?.username}}
                </button>
                <button type="button" ngbDropdownItem (click)="logout()">
                  <lucide-icon name="log-out" style="margin-right:4px;" size="18"></lucide-icon>
                  {{'HEADER.LOGOUT' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  }

  <!-- ── Mobile overlay nav (below xl breakpoint only) ── -->
  @if (mobileMenuOpen) {
    <div class="mobile-nav-overlay d-xl-none" (click)="closeMobileMenu()">
      <div class="mobile-nav-panel" (click)="$event.stopPropagation()">
        <!-- Control type items -->
        <div class="mobile-nav-item">
          <button class="mobile-nav-link" (click)="controlTypesExpanded = !controlTypesExpanded">
            <lucide-icon name="cpu" class="mobile-nav-icon" size="16"></lucide-icon>
            <span>{{ controlTypeNameShort }}</span>
            <lucide-icon [name]="controlTypesExpanded ? 'chevron-up' : 'chevron-down'" class="mobile-chevron" size="16"></lucide-icon>
          </button>
          @if (controlTypesExpanded) {
            <div class="mobile-nav-submenu">
              @for (value of controlTypes; track value) {
                <button class="mobile-nav-sublink"
                  (click)="onChangeType(value.key); closeMobileMenu()">
                  {{value.name.split(":")[0]}}
                </button>
              }
            </div>
          }
        </div>
        <a class="mobile-nav-link" routerLink="/control-module" routerLinkActive="mobile-nav-active"
          (click)="closeMobileMenu()">
          <lucide-icon name="list" class="mobile-nav-icon" size="16"></lucide-icon>
          <span>{{'HEADER.GENERAL' | translate}}</span>
        </a>
        <!-- Footer row: language + user actions -->
        <div class="mobile-nav-footer">
          <div class="mobile-lang-group">
            @for (code of languages; track code) {
              <img [src]="flagFor(code)" (click)="setLang(code)" [alt]="code"
                class="lang-flag" [class.lang-flag-fr]="code === 'fr'"
                [ngClass]="lang === code ? '' : 'unselected_lang'">
            }
          </div>
          <button class="mobile-footer-btn" (click)="navigateToNotifications(); closeMobileMenu()">
            <lucide-icon name="bell" size="19"></lucide-icon>
            @if (unseenNotifications > 0) {
              <span class="mobile-notif-badge">{{unseenNotifications}}</span>
            }
            <span class="mobile-footer-label">{{'NOTIFICATIONS.SEE_ALL' | translate}}</span>
          </button>
          <button class="mobile-footer-btn" (click)="userAccount(); closeMobileMenu()">
            <app-user-avatar [user]="user"></app-user-avatar>
            <span class="mobile-footer-label">{{user?.username}}</span>
          </button>
          <button class="mobile-footer-btn mobile-logout-btn" (click)="logout(); closeMobileMenu()">
            <lucide-icon name="log-out" size="19"></lucide-icon>
            <span class="mobile-footer-label">{{'HEADER.LOGOUT' | translate}}</span>
          </button>
        </div>
      </div>
    </div>
  }

</div>
